import { render, staticRenderFns } from "./map-legend.vue?vue&type=template&id=7d9615c1"
import script from "./map-legend.vue?vue&type=script&lang=js"
export * from "./map-legend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d9615c1')) {
      api.createRecord('7d9615c1', component.options)
    } else {
      api.reload('7d9615c1', component.options)
    }
    module.hot.accept("./map-legend.vue?vue&type=template&id=7d9615c1", function () {
      api.rerender('7d9615c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/map/map-legend.vue"
export default component.exports